import { AppContext } from '@/contexts/AppContext'
import { useContext } from 'react'

function useAppContext() {
  const {
    isMobile,
    setIsMobile,
    activePanel,
    setActivePanel,
    templates,
    setTemplates,
    shapes,
    setShapes,
    activeSubMenu,
    setActiveSubMenu,
    uploads,
    setUploads,
    currentTemplate,
    setCurrentTemplate,
    hasBgImage,
    setHasBgImage,
    isLoadedJsonSuccess,
    setIsLoadedJsonSuccess,
    objDragging,
    setObjDragging,
    isReplacingImage,
    setIsReplacingImage,
    isOpenPixelManipulationObject,
    setisOpenPixelManipulationObject,
    popoverActive,
    setPopoverActive,
    toolType,
    setToolType,
    isOpenTutorial,
    setIsOpenTutorial,
    saveProjectState,
    setSaveProjectState,
    isOpenFontFamily, 
    setIsOpenFontFamily,
    openToast,
    setOpenToast,
    resetEditorContext
  } = useContext(AppContext)
  return {
    isMobile,
    setIsMobile,
    activePanel,
    setActivePanel,
    templates,
    setTemplates,
    shapes,
    setShapes,
    activeSubMenu,
    setActiveSubMenu,
    uploads,
    setUploads,
    currentTemplate,
    setCurrentTemplate,
    hasBgImage,
    setHasBgImage,
    isLoadedJsonSuccess,
    setIsLoadedJsonSuccess,
    objDragging,
    setObjDragging,
    isReplacingImage,
    setIsReplacingImage,
    isOpenPixelManipulationObject,
    setisOpenPixelManipulationObject,
    popoverActive,
    setPopoverActive,
    toolType,
    setToolType,
    isOpenTutorial,
    setIsOpenTutorial,
    saveProjectState,
    setSaveProjectState,
    isOpenFontFamily, 
    setIsOpenFontFamily,
    openToast,
    setOpenToast,
    resetEditorContext
  }
}

export default useAppContext
